import { createMemo } from 'solid-js'
import type { Engine } from '../../lib/core/engine/Engine.type'
import findById from '../../lib/core/findById'
import type { Player } from '../../lib/core/player/Player.type'
import type { Nullable } from '../../typescript'
import { useAuthPlayerIdSignal } from './useAuthPlayerIdSignal'

/**
 * @deprecated
 */
export function createAuthPlayerMemo(engine: Engine) {
  const [getAuthPlayerId] = useAuthPlayerIdSignal(engine)
  const memo = createMemo((): Nullable<Player> => {
    return findById(engine.state.players, getAuthPlayerId())
  })
  return memo
}
